import Vue from 'vue'

export const a11yAnnouncements = Vue.observable({
  message: ''
})

function announce(message) {
  a11yAnnouncements.message = ''
  Vue.nextTick(() => {
    a11yAnnouncements.message = message
  })
}

export default {
  install(Vue, options) {
    Vue.prototype.$message = function(html) {
      announce(html)
      // M.toast({ html });
    }

    Vue.prototype.$error = function(html) {
      announce(`Ошибка: ${html}`)
      // M.toast({ html: `[Ошибка]:  ${html}` });
    }
  }
}
